import React from 'react';

const BackToTopButton = (): React.ReactElement => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="23.5" fill="white" stroke="#697684" />
      <path
        d="M32 23L24 15L16 23"
        stroke="#333F48"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 15V33"
        stroke="#333F48"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BackToTopButton;
